import { render } from "./ModalVariants.vue?vue&type=template&id=276c4c99&scoped=true"
import script from "./ModalVariants.vue?vue&type=script&lang=js"
export * from "./ModalVariants.vue?vue&type=script&lang=js"

import "./ModalVariants.vue?vue&type=style&index=0&id=276c4c99&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276c4c99"]])

export default __exports__